import React from 'react';
import {Form} from 'react-form';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import _ from 'lodash';
import Translate from 'translate';

import {FormGroup, Text, SelectCreatable, Checkbox} from 'components/FormElements/';
import CategoryService from 'services/CategoryService';
import {toggleLoading, toggleAlertError} from 'stores/actions/';
import {required} from 'constants/InputErrors';

class CategoryEdit extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: {}
    };

    this.entityId = props.match.params.id;
    this.getData = this.getData.bind( this );
    this.submitForm = this.submitForm.bind( this );
  }

  componentDidMount() {
    if( this.entityId ) this.getData()
  }

  getData() {
    this.props.toggleLoading( true );

    CategoryService.getCategory( this.entityId ).then( ( response ) => {
      this.props.toggleLoading( false );

      if( response.data ) {
        response.data.words = _.map( response.data.words, ( word, index ) => {
          return { id: index + 1, word }
        } );

        this.setState( { data: response.data } )
      }
    } )
  }

  submitForm( data ) {
    const { history, toggleAlertError, toggleLoading } = this.props;
    this.formData = _.cloneDeep( data );

    toggleLoading( true );
    data.words = _.map( data.words, 'word' );

    const promise = this.entityId ? CategoryService.updateCategory( this.entityId, data ) :
      CategoryService.saveCategory( data );

    promise.then( ( response ) => {
      toggleLoading( false );
      if( response.errors ) return toggleAlertError( response.errors );

      return history.push( '/configurations/categories' )
    } )
  }

  render() {
    return (
      <div className="box box-default">
        <div className="box-header">{this.entityId ? <Translate id="edit"/> : <Translate id="new"/>} <Translate id="category"/></div>
        <div className="box-body">
          <Form
            defaultValues={this.formData || this.state.data}
            onSubmit={this.submitForm}
            validate={( values ) => {
              return {
                category: required( values.category ),
              }
            }}
          >
            {( { submitForm } ) =>
              <form onSubmit={submitForm}>
                <FormGroup>
                  <label><Translate id="name"/></label>
                  <Text field="category" className="form-control"/>
                </FormGroup>

                <div className="row">
                  <FormGroup containerClass="col-md-6">
                    <label><Translate id="externalCode"/></label>
                    <Text field="codExt" className="form-control"/>
                  </FormGroup>

                  <FormGroup containerClass="col-md-6">
                    <label><Translate id="keys"/></label>
                    <SelectCreatable field="words" className="form-control" placeholder=""
                                     multi
                                     options={_.cloneDeep( this.state.data.words )}
                                     labelKey="word"/>
                  </FormGroup>
                </div>

                <FormGroup containerClass="col-md-2 pl-0">
                  <Checkbox field="active" label={<Translate id="active"/>}/>
                </FormGroup>

                <div className="text-right mt-4">
                  <Link to={`/configurations/categories`}>
                    <button className="btn btn-outline-secondary px-4 mr-2">
                      <Translate id="cancel"/>
                    </button>
                  </Link>
                  <button type="submit" className="btn btn-info px-4"><Translate id="save"/></button>
                </div>
              </form>
            }
          </Form>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
});

module.exports = connect(
  null,
  mapDispatchToProps
)( CategoryEdit );



// WEBPACK FOOTER //
// ./routes/app/routes/configuration/categories/edit/index.js